import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'soft-field-ok-leiter-list-view',
  imports: [],
  templateUrl: './leiter.list-view.html',
  styleUrls: ['./leiter.list-view.css'],
})
export class LeiterListView implements FieldOkItemComponent<any> {
  readonly item = input<any>();
}
